<div class="root-container">
  <customer-header />
  <div class="content scrollbars" #scrollContainer>
    <div style="flex: 1">
      <div class="container">
        <router-outlet />
      </div>
    </div>
    <public-footer />
  </div>
  <scroll-to-top #scrollTop [scrollContainerRef]="scrollContainer" />
  <toast #toast />
  <modals #modals />
  <login-modal #login_modal />
</div>
